module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.productFlow.update.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('form.productFlow.basicInformation'),
      "name": "first"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.formBasicInformation,
      "translation": "form.productFlow",
      "hasLabel": true
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'productFlow.index'
      }
    }
  }, [_c('el-button', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "outline",
    attrs: {
      "loading": _vm.formBasicInformation.loading
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f383a08","hasScoped":false}!./src/app/pages/withNavigation/productFlow/edit/edit.html
// module id = 3003
// module chunks = 1